import { apiGet } from './client';

// Workbench MVP Session A — Flight Recorder.
// Trace ID is the underlying BenchmarkRun.Id or ChatRun.Id (a Guid). RunType
// is the discriminator so the UI can badge benchmark vs chat.

export type TraceRunType = 'benchmark' | 'chat';

export interface TraceListItem {
  traceId: string;
  runType: TraceRunType;
  label: string;
  startedAt: string;
  totalDurationMs: number | null;
  stepCount: number;
  providerCount: number;
  hasErrors: boolean;
  hasSlaBreach: boolean;
}

export interface TraceStep {
  eventId: string;
  step: string;
  status: 'started' | 'completed' | 'failed';
  providerId: string | null;
  nodeId: string;
  latencyMs: number | null;
  slaBudgetMs: number | null;
  slaBreached: boolean;
  occurredAt: string;
}

export interface TraceDetail extends TraceListItem {
  steps: TraceStep[];
}

export const listRecentTraces = (limit = 50) =>
  apiGet<TraceListItem[]>(`/api/traces?limit=${limit}`);

export const getTrace = (traceId: string) =>
  apiGet<TraceDetail>(`/api/traces/${encodeURIComponent(traceId)}`);

export const getTraceSteps = (traceId: string) =>
  apiGet<TraceStep[]>(`/api/traces/${encodeURIComponent(traceId)}/steps`);
